package com.damda.design_system.ui.screens


import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.damda.design_system.core.ImageResourceLoader
import com.damda.design_system.ui.views.compose_migrations.images.JSRoundedImage
import com.damda.design_system.ui.views.compose_migrations.layouts.JSLargeBanner
import com.damda.design_system.ui.views.compose_migrations.layouts.JSRow
import com.damda.design_system.ui.views.compose_migrations.layouts.JSSpacer
import com.damda.design_system.ui.views.compose_migrations.texts.JSHeaderSection
import com.damda.design_system.ui.views.compose_migrations.texts.JSHeaderText
import com.damda.design_system.ui.views.compose_migrations.texts.StyledText
import com.damda.design_system.ui.views.core.ComposeWindowWidthSizeClass
import com.damda.design_system.ui.views.core.JSViewPadding
import com.damda.design_system.ui.views.food_carts.ShoppingCartIcon
import com.damda.design_system.ui.views.foods.JSFoodList
import com.damda.design_system.ui.views.lists.FoodItem
import com.damda.design_system.ui.views.lists.foodItems
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.paddingRight
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div

@Composable
fun HomeScreen(
    windowSize: ComposeWindowWidthSizeClass,
    imageResourceLoader: ImageResourceLoader = ImageResourceLoader(),
    homeDefaultHorizontalPadding: JSViewPadding = JSViewPadding(30.px, 0.px, 30.px, 0.px),
    onCardClick: (FoodItem) -> Unit,
    onCartClick: () -> Unit,
    cartCount: Int
) {
    var reduceFontSize by remember { mutableStateOf(0.px) }

    val newFontSize = when (windowSize) {
        ComposeWindowWidthSizeClass.Small -> 4.px
        ComposeWindowWidthSizeClass.Medium -> 2.px
        ComposeWindowWidthSizeClass.Large -> 0.px
        else -> {0.px}
    }
    reduceFontSize = newFontSize

    Div (attrs = {
        style {
            overflowY("auto") // 세로 스크롤 가능하게 설정
        }
        style {
            // 수평 및 수직 스크롤바 숨기기
            property("-ms-overflow-style", "none") // IE and Edge
            property("scrollbar-width", "none") // Firefox
            property("::-webkit-scrollbar", "display:none") // Chrome, Safari, Opera
        }
    }) {
        JSSpacer(height = 24.px)
        Div (attrs = {
            style {
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.SpaceBetween)
                alignItems(AlignItems.Center)
                width(100.percent)
                maxWidth(100.percent)
            }
            }
        ){
            JSRow(padding = homeDefaultHorizontalPadding) {
                JSRoundedImage(imageResourceLoader, "hadgehog.png")
                JSSpacer(width = 10.px)
                JSHeaderText(title = "왁자지껄 해지호그", subtitle = "Pincho & Wine")
            }
            Div (
                {
                    style {
                        paddingRight(homeDefaultHorizontalPadding.right)
                    }
                }
            ){
                ShoppingCartIcon(cartCount, onCartClick)
            }
        }
        JSSpacer(height = 24.px)
        StyledText(
            text = "을지로에서 만나는 \uD83C\uDF77와인과 \uD83C\uDF5D파스타",
            fontSize = 18.px,
            padding = homeDefaultHorizontalPadding,
            reduceFontSize = reduceFontSize
        )
        JSSpacer(height = 2.px)
        StyledText(
            text = "최고의 조화를 경험해보세요! \uD83D\uDE0B",
            fontSize = 18.px,
            padding = homeDefaultHorizontalPadding,
            reduceFontSize = reduceFontSize
        )
        JSSpacer(height = 30.px)
        JSLargeBanner(
            imageResourceLoader = imageResourceLoader,
            imageName = "ic_dynamic_bell.png",
            title = "알림 2024.06.03 정식 오픈합니다.\n해지호그에서만 느낄수 있는 와인맥주와 핀초의 만남을 느껴보세요",
            subtitle = "개봉박두!!",
            buttonText = "Buy Now",
            padding = homeDefaultHorizontalPadding,
            reduceFontSize = reduceFontSize,
            onButtonClick = { /* Handle button click */ }
        )
        JSSpacer(height = 30.px)
        JSHeaderSection(
            title = "인기순",
            subtitle = "가게에서 제일 잘 나가는 메뉴들이에요\uD83D\uDE0B",
            actionText = "모두 보기",
            padding = homeDefaultHorizontalPadding,
            reduceFontSize = reduceFontSize,
            onActionClick = { /* Do something */ }
        )
        JSFoodList(
            imageResourceLoader = imageResourceLoader,
            items = foodItems,
            onAddToCartClick = { /* Do something */ },
            onCardClick = onCardClick
        )
        JSHeaderSection(
            title = "신메뉴",
            subtitle = "HEDGEHOG가 열심히 준비한 신메뉴들이에요\uD83D\uDE0B",
            actionText = "모두 보기",
            padding = homeDefaultHorizontalPadding,
            reduceFontSize = reduceFontSize,
            onActionClick = { /* Do something */ }
        )
        JSFoodList(
            imageResourceLoader = imageResourceLoader,
            items = foodItems.reversed(),
            onAddToCartClick = { /* Do something */ },
            onCardClick = onCardClick
        )
    }
}